<script>
/**
 * 受注（回収）登録モーダル
 */
import orderForm from '../../orders/accepts/collection/_Form.vue'

export default {
  name: "AddOrderCollectionModal",
  components: {
    orderForm
  },
  props: {
    /**
     * モーダル表示設定
     * @default false
     */
    enableDialog: {
      type: Boolean,
      default: false,
    },
    /**
     * 対象日
     * @default null
     */
    targetDate: {
      type: String,
      default: null,
    },
    /**
     * 運搬担当者ID
     * @default null
     */
    transportUserId: {
      type: Number,
      default: null,
    },
    /**
     * 運搬担当者名
     * @default null
     */
    transportUserName: {
      type: String,
      default: null,
    },
  },
  watch: {
    /**
     * モーダル表示制御
     * @param val
     */
    enableDialog (val) {
      if (val) {
        /*
         * モーダル表示時の初期化処理
         * キーをインクリメントすることで受注Formを再描画させる
         */
        this.key += 1;
      }
    },
    /**
     * 対象日の監視
     * 対象日がシステム日より未来の場合、受注登録画面の「過去マニフェストの起票」は表示しない対応
     * @param val
     */
    targetDate (val) {
      const dateFrom = this.$dayjs(val)
      const dateTo = this.$dayjs(this.$dayjs().format("YYYY-MM-DD"))
      this.hidePastManifest = dateFrom.isAfter(dateTo)
    },
  },
  data() {
    return {
      key: 0,
      buttonLocked: false,
      hidePastManifest: false,
    }
  },
  methods: {
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback');
    },
    /**
     * 受注登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      this.$refs.orderForm.registerOrderButtonClickEvent();
    },
    /**
     * 受注登録 コールバック
     */
    registerCallback () {
      this.$emit('registerCallback');
    },
    /**
     * ボタン制御
     * @param value
     */
    loadingCallback (value) {
      this.buttonLocked = value
    }
  }
}
</script>

<template>
  <v-dialog
    :value="enableDialog"
    fullscreen
    persistent
    scrollable
    transition="dialog-bottom-transition"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <v-card flat rounded="false">
      <v-card-title
        class="primary white--text"
      >
        受注登録（産廃）
        <v-spacer />
        <v-btn
          icon
          dark
          @click="closeButtonClickEvent"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-container>
          <order-form
            ref="orderForm"
            :key="key"
            :driver-schedule-target-date="targetDate"
            :driver-schedule-transport-user-id="transportUserId"
            :driver-schedule-transport-user-name="transportUserName"
            :hide-past-manifest="hidePastManifest"
            load-by="driver_schedule"
            @registerCallback="registerCallback"
            @loadingCallback="loadingCallback"
          />
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="closeButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          :disabled="buttonLocked"
          class="mr-15"
          color="primary"
          @click="registerButtonClickEvent"
        >
          受注登録
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">

</style>
